module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3212-ebc47579923d5a31f88b717c9f079a79.jpg";